import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import WithTransition from './../../hoc/WithTransition';


class Button extends Component {

	lastText = '';

	render() {

		const mainClasses = classNames({
			[this.props.classBEMRoot]: true,
			[this.props.className]: this.props.className,
			[this.props.classBEMRoot + '--active']: this.props.active,
			[this.props.classBEMRoot + '--disabled']: this.props.disabled,
			'dpit-hovered': this.props.hovered
		});

		let renderedText = (this.props.inTransition) ? this.lastText : this.props.text;
		this.lastText = renderedText;

		const title = this.props.title === undefined ? this.props.text : this.props.title;

		const buttonContent = (
			<Fragment>
				{this.props.children}
				{renderedText
					? (!this.props.addSpanForText
						? renderedText
						: <span className={this.props.classBEMRoot + '__text'}>{renderedText}</span>)
					: null}
			</Fragment>
		);

		let button = null;

		if (this.props.href) {
			button = (
				<a
					className={mainClasses}
					onMouseEnter={this.props.onMouseEnter}
					onMouseLeave={this.props.onMouseLeave}
					href={this.props.href}
					title={title}
					target={this.props.target}
					/* rel="noopener noreferrer" */
					style={this.props.buttonStyle}
					onClick={this.props.onClick}
				>
					{buttonContent}
				</a>
			);
		}
		else {
			button = (
				<div
					onMouseEnter={this.props.onMouseEnter}
					onMouseLeave={this.props.onMouseLeave}
					disabled={this.props.disabled}
					className={mainClasses}
					href={this.props.href}
					title={title}
					style={this.props.buttonStyle}
					onClick={this.props.onClick}
				>
					{buttonContent}
				</div>
			);
		}
		return button;
	}
}
export default Button;
export const ButtonWithTransition = WithTransition(Button);

